import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Loader(props: Partial<SVGProps<any>>) {
  return (
<svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
<circle cx="14" cy="14" r="6" fill="#FF00FE">
<animate attributeName="opacity" values="0.3;1;0.3" dur="1.2s" repeatCount="indefinite" begin="0s"></animate>
</circle>

<circle cx="34" cy="14" r="6" fill="#FF00FE">
<animate attributeName="opacity" values="0.3;1;0.3" dur="1.2s" repeatCount="indefinite" begin="0.2s"></animate>
</circle>

<circle cx="24" cy="34" r="6" fill="#FF00FE">
<animate attributeName="opacity" values="0.3;1;0.3" dur="1.2s" repeatCount="indefinite" begin="0.4s"></animate>
</circle>
</svg>
  )
}